import { SSOLogoutReason } from '../../services/sso/types';

export const getLogoutReason = (status: string): SSOLogoutReason => {
    const reason = Object.entries(SSOLogoutReason).find(([key]) => key === status);

    if (!reason) {
        return SSOLogoutReason.UNKNOWN;
    }

    return reason[1];
};
